import React from 'react';
import {useViewerStore} from "../../../../store/store";
import {X} from '@phosphor-icons/react';


interface ModalProps {
    title: string;
    children: React.ReactNode;
    close?: () => void;
}

const Modal = ({title, children, close}: ModalProps) => {

    const isSavingInProgress = useViewerStore(state => state.isSavingInProgress)

    return (
        <div className='modal top aligned'>
            <div className='modal__overlay'></div>
            <div className='modal__content'>
                <div className='modal__header'>
                    <span className={'modal__title'}>{title}</span>
                    {
                        !isSavingInProgress &&

                        <span
                            title={'Close'}
                            className={"modal__close__btn"}
                            style={{marginLeft: "10px"}}
                            onClick={() => close?.()}
                        >
                    <X size={20} weight="bold" color={"white"}/>
                        </span>
                    }

                </div>
                <div className='modal__inner'>
                    {children}
                </div>
            </div>
        </div>
    );
}

export default Modal;